$(document).ready(function (){

    $(".start_assortment").on('click', function (){
        let data = new FormData()
        data.append('uuid',$(this).data('uuid'))
        data.append('order_id',$(this).data('order_id'))
        data.append('id',$(this).data('id'))

        Swal.fire({
            title: '¿Estas seguro?',
            text: "El pedido sera iniciado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#023B59',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, iniciar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                sendData(data,"/start_assortment")
            }
        })



    })

    $(".finished_assortment").on('click', function (e){
        e.preventDefault()
        let data = new FormData()
        data.append('uuid',$(this).data('uuid'))
        data.append('order_id',$(this).data('order_id'))
        data.append('id',$(this).data('id'))
        Swal.fire({
            title: '¿Estas seguro?',
            text: "El pédido sera finalizado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#023B59',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, finalizar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                sendData(data,"/finished-assortment")
            }
        })

    })

    //Pedido finalizado por el checador
    $(".finished_assortmen_checador").on('click', function (e){
        e.preventDefault()
        let data = new FormData()
        data.append('uuid',$(this).data('uuid'))
        Swal.fire({
            title: '¿Estas seguro?',
            text: "El pédido sera finalizado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#023B59',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, finalizar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                sendData(data,'/finished-assortment-check')
            }
        })
    })

    //Se muestra modal para ingresar el comentario sobre el articulo pospuesto para surtir
    $(".modal-postpone").on('click', function (e){
        e.preventDefault()
        $(".article_detail_id").val($(this).data('article_detail_id'))
        $(".order_uuid").val($(this).data('order_uuid'))
        $("#modal-postpone").modal('show')
    })

    $("#form-postpone").on('submit', function (e){
        e.preventDefault()
        let data = new FormData(this)
        let route = "/save-comment-article-postponed"
        sendData(data,route)
    })

    $(document).on('change', '.only-one', function() {
        if ($(this).is(':checked')) {
            $('.only-one').not(this).prop('checked', false);
            $(".article_id").val($(this).data('article_id'))
            $(".order_uuid").val($(this).data('uuid'))
            $("#modal-comment-assortment-replenish-order").modal('show')
        }else{
            $(".article_id").val('')
            $(".order_uuid").val('')
        }
    });

    $('.btn_cancel_').on('click', function (){
        $('.only-one').prop('checked', false);
    })

    $("#form-assortment-replenish").on('submit', function (e){
        e.preventDefault()
        let data = new FormData(this)
        sendData(data,'/assortment-replenish')
    })

    function sendData(data, route) {
        $.ajax({
            data: data,
            url: route,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        }).done(function (response) {

            if (response.success) {
                Swal.fire({
                    title: '',
                    text: response.message,
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.isConfirmed) {
                        location.reload()
                    }
                });
            }else{
            alertError(response.message)
            }
        }).fail(function (jqXHR, textStatus) {
            console.log(textStatus)
        });
    }
})
